import React, { createContext, useState, useEffect } from 'react';
import { fetchConfigColors } from 'api';

export const ColorsContext = createContext({ colors: null, loading: true });

function setCssVars(obj) {

  if (!obj) return;
  
  Object.entries(obj).forEach(([key, val]) => {
    try { document.documentElement.style.setProperty(`--color-${key}`, val); } catch (e) {}
  });

}

export function ColorsProvider({ children }) {

  const [colors, setColors] = useState(() => {

    try {
      return JSON.parse(localStorage.getItem('app_colors'));
    } catch (e) {
      return null;
    }

  });

  const [loading, setLoading] = useState(!colors);

  useEffect(() => {

    let mounted = true;
    async function load() {

      try {

        const resp = await fetchConfigColors();
        const config = resp && resp.data ? resp.data : resp;

        if (!mounted) return;

        setColors(config);

        localStorage.setItem('app_colors', JSON.stringify(config));
        
        setCssVars(config);

      } catch (e) {
         console.error('fetchConfigColors error', e.message, e.response && e.response.data);
      } finally {
        if (mounted) setLoading(false);
      }

    }

    if (!colors){
      load();
    }
    else {
      setCssVars(colors);
      setLoading(false);
    }

    return () => { mounted = false };

  }, []);

  return (
    <ColorsContext.Provider value={{ colors, loading }}>
      {children}
    </ColorsContext.Provider>
  );

}


// WEBPACK FOOTER //
// ./src/context/ColorsProvider.js